import { Box, CircularProgress } from '@mui/material'
import { Modal } from 'Components/Modal'
import { useState } from 'react'
import { TextFieldWithLabel } from 'Components/TextField'
import { LargeCard } from 'Components/Cards/Large'
import { type DuplicateHandlingContact } from './DuplicateHandlingContact'

interface DuplicateHandlingContactEditProps {
  onClose: () => void
  show: boolean
  contact: DuplicateHandlingContact
  onConfirm: (contact: DuplicateHandlingContact) => void
}

export function DuplicateHandlingContactEdit (props: DuplicateHandlingContactEditProps): JSX.Element {
  const [contact, setContact] = useState<DuplicateHandlingContact>(props.contact)
  const [isRequestLoading, setIsRequestLoading] = useState<boolean>(false)

  const handleChange = (e: any): void => {
    setContact({ ...contact, [e.target.name]: e.target.value })
  }

  const onConfirm = async (): Promise<void> => {
    if (!isRequestLoading) {
      setIsRequestLoading(false)
      props.onConfirm(contact)
    }
  }

  if (contact === null) return <CircularProgress role='loading' />

  const contactContent = <Box>
    <TextFieldWithLabel type='text' data-testid='contact-name' label='Name' name='name' maxLength={100} onChange={handleChange} value={contact.name ?? ''} />
    <TextFieldWithLabel type='email' data-testid='contact-email' label='Email' name='email' maxLength={100} onChange={handleChange} value={contact.email ?? ''} />
  </Box>

  return (
    <Modal
      onClose={props.onClose}
      onConfirm={onConfirm}
      open={props.show}
      confirmationContent={<LargeCard header='' content={contactContent} className='mt-10' fullWidth={true} />}
      title='Edit Duplicate Handling Contact'
    />
  )
}
